import React from 'react'
import FounderContacts from '../../../components/Front/FounderContacts/FounderContacts'
import FounderPicture from '../../../assets/images/front/foudner.png'

const Founder: React.FC = () => {
  return (
    <div className="container mt-[52px] md:mt-[88px] py-6 md:py-12 mx-4 px-4 text-[#333] overflow-hidden">
      <h1 className="text-[#0183BA] mb-3 text-xl md:text-[25px] text-center">
        Jiří Žežulka, zakladatel
      </h1>
      <div className="flex flex-col lg:flex-row items-start">
        <div className="leading-[22px] mb-12 lg:mb-0">
          <div className="bg-[#A8CD00] pb-3 lg:py-5 ps-4 pe-3 mt-6 lg:rounded-s-3xl mb-3 relative">
            <img
              src={FounderPicture}
              alt=""
              className="w-100 mx-auto block lg:hidden -top-5 relative"
            />
            <p className="mb-3 relative">
              <span className="absolute -top-12 left-0 z-100 text-[122px] leading-none text-white lg:text-[#0183BA] font-bold font-myriad">
                “
              </span>
              „S doučováním jsem začal na gymnáziu a věnuji se mu téměř šestnáct let. Pomáhat
              studentům rozvíjet a upevňovat jejich vědomosti mě vždy bavilo a z jejich reakcí vím,
              že to přináší pozitivní výsledky.{' '}
            </p>
            <p>
              Z malé firmy na doučování jsme vybudovali společnost, která přináší moderní a
              inovativní způsoby předávání znalostí. Baví mě hledat způsoby, jak naše studenty
              nejlépe připravit na přijímací zkoušky a pomoci jim získat potřebné vědomosti. Věřím,
              že Dohlavy dokáže pomoci i vám."
            </p>
          </div>
          <p className="px-4">
            Styl a způsob výuky zakladatele Jiřího Žežulky prostupuje celou společností a vším, co
            Dohlavy dělá — ať už jde o online kurzy (kde je často lektorem přímo on), obsah, který
            sám vytváří, nebo o videa na Instagram, YouTube a TikTok kanálech Dohlavy, kde řeší
            desítky různých úloh a ukazuje, že látka může být občas překvapivě jednoduchá.
          </p>
        </div>
        <img src={FounderPicture} alt="" className="w-100 hidden lg:block" />
      </div>
      <h2 className="text-[#0183BA] mb-3 text-xl md:text-[25px] text-center">Doučto</h2>
      <div className="leading-[22px] px-4">
        <p className="mb-3">
          Jiří Žežulka aktuálně spolupracuje také na projektu DouČTo, novém živém pořadu vzdělávací
          platformy ČT edu. Ten od ledna běží každé úterý od 18:00 na YouTube, Twitchi a iVysílání
          České televize. Pomáhá deváťákům porozumět matematice i češtině způsobem, který je
          přístupný, srozumitelný a zaměřený na praktické pochopení úloh.
        </p>
        <p className="mb-3">
          Pořad se soustředí hlavně na typy úloh, které jsou ve skutečnosti jednoduché, ale žáci v
          nich často zbytečně chybují, na slovní úlohy, kterých se mnoho deváťáků bojí už při čtení
          zadání, i na nejčastější cermatovské chytáky. Cílem je ukázat, že příprava nemusí být
          dřina — když žák ví, jak k úloze přistupovat, dokáže najít rychlejší a jednodušší cestu k
          výsledku. Součástí je také práce s časem a osobní strategií, která často rozhoduje o
          úspěchu.
        </p>
        <p className="mb-12 pb-6">
          Jiří se tak i v rámci DouČTa drží svého dlouhodobého přístupu: pomáhat deváťákům získat
          jistotu, pochopit principy a vidět, že řadu úloh lze řešit chytře a s menším stresem.
          Pořad je skvělým doplňkem k přípravě a vede žáky k tomu, aby se nebáli řešit úlohy
          samostatně a přemýšleli u nich efektivně.
        </p>
      </div>
      <FounderContacts />
    </div>
  )
}

export default Founder
